export default "__VITE_ASSET__DRm6BDLj__"